import * as React from 'react';
import classnames from 'classnames';
import styles from './icons.scss';

function DocumentIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={classnames(styles.icons, props.className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-.293-.707l-2-2-2-2A1 1 0 0014 3H6zm1 16V5h5v3a2 2 0 002 2h3v9H7zm9.586-11l-1.293-1.293L14 5.414V8h2.586z" />
    </svg>
  );
}
export default React.memo(DocumentIcon);
